import { reactive, readonly } from "vue";

const state = reactive({
  active: false,
  message: "",
  _count: 0,
});

/**
 * Show the global full-screen preloader.
 * Nested calls increment a counter; each hide() decrements. Loader stays visible until count reaches 0.
 * @param {string} [message]
 */
export function showGlobalLoader(message = "") {
  if (message) {
    state.message = message;
  }
  state._count += 1;
  state.active = true;
}

/**
 * Hide the global preloader.
 */
export function hideGlobalLoader() {
  state._count = Math.max(0, state._count - 1);
  if (state._count === 0) {
    state.active = false;
    state.message = "";
  }
}

/**
 * Run an async function under the global loader.
 * @param {() => Promise<void>} fn
 * @param {string} [message]
 */
export async function withGlobalLoader(fn, message = "") {
  showGlobalLoader(message);
  try {
    await fn();
  } finally {
    hideGlobalLoader();
  }
}

export function isGlobalLoaderActive() {
  return state.active;
}

export function getGlobalLoaderState() {
  return readonly(state);
}

/** Reactive loader state for App.vue bindings. */
export const loaderState = state;

export default {
  install(app) {
    app.config.globalProperties.$showGlobalLoader = showGlobalLoader;
    app.config.globalProperties.$hideGlobalLoader = hideGlobalLoader;
    app.config.globalProperties.$withGlobalLoader = withGlobalLoader;
  },
};